"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _pick2 = _interopRequireDefault(require("lodash/pick"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = exports["default"] = function _default(props) {
  return (0, _pick2["default"])(props, ['field', 'settings', 'accommodations', 'setParameters', 'registerAction', 'template', 'templateExtraProps', 'playerTemplateProps', 'isPrintMode']);
};